import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'
import { Grid, Flex } from '@chatterbug/aaron'

import SelfAssessmentSkeleton from './SelfAssessmentSkeleton'

const SelfAssessmentPlaceholder = () => {
  return (
    <SelfAssessmentSkeleton
      sliderSection={
        <LoadingBox
          height="8px"
          width="90%"
          maxWidth="350px"
          borderRadius="1x"
        />
      }
      titleSection={<LoadingBox width="90px">&nbsp;</LoadingBox>}
      explanationSection={
        <Grid justifyItems="center" gap="1x">
          <LoadingBox width="80%" maxWidth="500px">
            &nbsp;
          </LoadingBox>
          <LoadingBox width="50%" maxWidth="500px">
            &nbsp;
          </LoadingBox>
        </Grid>
      }
      buttonSection={
        <Flex justifyContent="center">
          <LoadingBox width="150px" height="35px" borderRadius="1,5x">
            &nbsp;
          </LoadingBox>
        </Flex>
      }
    />
  )
}

export default SelfAssessmentPlaceholder
